// src/layout/AccountStatusWrapper.js - VERSION AVEC DISTINCTION ADMIN/MEMBRE

import React, { useState, useEffect } from 'react'
import { CSpinner } from '@coreui/react'
import { useSelector } from 'react-redux'
import SuspendedAccount from '../views/suspended/SuspendedAccount'
import PendingValidation from '../views/pending/PendingValidation'
import SubscriptionExpiredAdmin from '../views/subscription/SubscriptionExpiredAdmin'
import SubscriptionExpiredMember from '../views/subscription/SubscriptionExpiredMember'
import { Navigate } from 'react-router-dom'
import { get } from '../utils/apiClient'

function AccountStatusWrapper({ children }) {
  const currentUser = useSelector((state) => state.user?.user)
  const [accountStatus, setAccountStatus] = useState({
    isLoading: true,
    isSuspended: false,
    isValidated: true,
    isAuthenticated: null,
    hasActiveSubscription: true,
  })

  useEffect(() => {
    const checkAccountStatus = async () => {
      // ✅ SECURITY: Vérifier via userId (cookie httpOnly gère l'auth)
      const userId = localStorage.getItem('userId')

      if (!userId) {
        setAccountStatus((prev) => ({
          ...prev,
          isLoading: false,
          isAuthenticated: false,
        }))
        return
      }

      // Note: L'expiration du cookie est gérée côté serveur
      // Le serveur retournera 401 si le cookie a expiré (intercepté par apiClient)

      try {
        const statusData = await get('/members/status')

        // Vérifier l'abonnement
        let hasActiveSubscription = true
        try {
          const entitlementsData = await get('/me/entitlements')
          hasActiveSubscription = entitlementsData.canAccessPlatform
          console.log('📊 Vérification abonnement:', {
            canAccess: hasActiveSubscription,
            status: entitlementsData.status,
          })
        } catch (error) {
          console.warn('Erreur vérification abonnement, accès autorisé par défaut:', error)
          hasActiveSubscription = true
        }

        setAccountStatus({
          isLoading: false,
          isSuspended: Boolean(statusData.suspended),
          isValidated: Boolean(statusData.validated),
          isAuthenticated: true,
          hasActiveSubscription,
        })
      } catch (error) {
        console.error('Erreur complète:', error)
        setAccountStatus((prev) => ({
          ...prev,
          isLoading: false,
          isAuthenticated: true,
          hasActiveSubscription: true,
        }))
      }
    }

    checkAccountStatus()
  }, [])

  if (accountStatus.isLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <CSpinner color="primary" />
      </div>
    )
  }

  if (accountStatus.isAuthenticated === false) {
    return <Navigate to="/login" replace />
  }

  // 1. Compte suspendu (priorité max)
  if (accountStatus.isSuspended) {
    return <SuspendedAccount />
  }

  // 2. Validation en attente
  if (!accountStatus.isValidated) {
    return <PendingValidation />
  }

  // 3. Abonnement expiré - DISTINCTION ADMIN/MEMBRE
  if (!accountStatus.hasActiveSubscription) {
    console.log('⚠️ Abonnement inactif détecté')
    console.log('👤 Rôle utilisateur:', currentUser?.role)

    // Si admin → page avec choix d'abonnement
    if (currentUser?.role === 'admin') {
      return <SubscriptionExpiredAdmin />
    }

    // Si membre → page d'information simple
    return <SubscriptionExpiredMember />
  }

  // 4. Tout OK
  return children
}

export default AccountStatusWrapper
